import React from 'react';
import { SkeletonLine } from '@one-thd/sui-atomic-components';

const programSkeletonSection = (
  <div className="sui-w-full sui-mb-12">
    <SkeletonLine />
  </div>
);

const FAQSkeletonSection = (
  <div className="sui-w-full sui-mb-12">
    <div className="sui-mb-8">
      <SkeletonLine variant="heading" fullWidth />
    </div>
    <SkeletonLine numberOfLines="3" fullWidth />
  </div>
);

export const SectionSkeleton = ({
  section,
}: {
  section: 'program' | 'FAQ';
}) => {
  switch (section) {
    case 'program':
      return (
        <div className="sui-w-full sui-mt-8">
          {Array(3).fill(programSkeletonSection)}
        </div>
      );
    case 'FAQ':
      return <div>{Array(4).fill(FAQSkeletonSection)}</div>;
    default:
      return <div>{Array(6).fill(programSkeletonSection)}</div>;
  }
};
